import React from 'react'

const PhotoOnWall = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/photo_on_wall.svg" alt="photo_on_wall"/>
  )
}

export default PhotoOnWall